export default __webpack_public_path__ + "static/media/ci_202205.2ab5327e.png";